import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Login from './components/Login'
import BlogsAndVideos from './components/BlogsAndVideos'
import UserStats from './components/UserStats'
import PrivateRoute from './components/PrivateRoute'
import MLStats from './components/MLStats'
import OnboardingFunnel from './components/OnboardingFunnel'
import FeedInteractions from './components/FeedInteractions'
import B2BUserMetrics from './components/B2BUserMetrics'
import ProductAnalytics from './components/ProductAnalytics'
import EngagementMetrics from './components/EngagementMetrics'
import ContactInbox from './components/ContactInbox'

function App() {
  return (
    <Routes>
      <Route path="/contacts" element={<PrivateRoute><ContactInbox /></PrivateRoute>} />
      <Route path="/login" element={<Login />} />
      <Route path="/" element={
        <PrivateRoute>
          <UserStats />
        </PrivateRoute>
      } />
      <Route path="/aiAnalytics" element={
        <PrivateRoute>
          <MLStats />
        </PrivateRoute>
      } />
      <Route path="/onboardingFunnel" element={
        <PrivateRoute>
          <OnboardingFunnel />
        </PrivateRoute>
      } />
      <Route path="/productAnalytics" element={
        <PrivateRoute>
          <ProductAnalytics />
        </PrivateRoute>
      } />
      <Route path="/engagement" element={
        <PrivateRoute>
          <EngagementMetrics />
        </PrivateRoute>
      } />
      <Route path="/blogsVideo" element={
        <PrivateRoute>
          <BlogsAndVideos />
        </PrivateRoute>
      } />
      <Route path="/feedEngagement" element={
        <PrivateRoute>
          <FeedInteractions />
        </PrivateRoute>
      } />
      <Route path="/b2b" element={
        <PrivateRoute>
          <B2BUserMetrics />
        </PrivateRoute>
      } />
      <Route path="/b2bUsers" element={
        <PrivateRoute>
          <B2BUserMetrics />
        </PrivateRoute>
      } />
    </Routes>
  )
}

export default App
